import { isBefore, isAfter, addSeconds } from 'date-fns';

export const isInEventDateRange = (dateToCompare: Date, startDate: Date, endDate: Date) => {
	const limitStart = addSeconds(startDate, -1);
	const limitEnd = addSeconds(endDate, 1);
	
	const isEventStart = isAfter(dateToCompare, limitStart);
	const isEventEnd = isBefore(dateToCompare, limitEnd);

	return isEventStart && isEventEnd;
};


export const extractDateParts = (date: string | Date) => {
	const d = new Date(date);
	const year = d.getFullYear();
	const month = String(d.getMonth() + 1).padStart(2, '0');
	const day = String(d.getDate()).padStart(2, '0');
	const hours = String(d.getHours()).padStart(2, '0');
	const minutes = String(d.getMinutes()).padStart(2, '0');
	const seconds = String(d.getSeconds()).padStart(2, '0');
	
	return { year, month, day, hours, minutes, seconds };
};

export const formatExpireDateWithTime = (expireDate: string) => {
	if (!expireDate) return '';

	const hasDateTime = expireDate.match(/^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})/);
	if (hasDateTime) {
		const [, year, month, day, hours, minutes] = hasDateTime;
		return `${year}/${month}/${day} ${hours}:${minutes} (GMT-4)`;
	}

	const { year, month, day, hours, minutes } = extractDateParts(expireDate);
	return `${year}/${month}/${day} ${hours}:${minutes} (GMT-4)`;
};